export default __webpack_public_path__ + "e6b20a4a2346e8e85196e076270be376.png";